import { Injectable } from '@angular/core';
import { SelfSelectorField } from './blockly/custom-fields/self-selector-field';

@Injectable()
export class NgCustomBlocklyService {

  constructor() { }

  /**
   * 初始化自定义的Field, 并注册该自定义的field,'self-selector'
   *
   * @memberof NgBlocklyService
   */
  initCustomField() {
    // tslint:disable-next-line: no-unused-expression
    new SelfSelectorField();
  }
}
